import { getSpendReport } from "@iewcasia/Services/CommonService";
import { CustomState } from "@iewcasia/Store/Reducers";
import { SpendReportModel } from "@iewcasia/Types/CustomApiModels";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnErrorIsSet,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";

type SpendReportingParameter = HasOnSuccess & HasOnError;

type HandlerType = ApiHandlerDiscreteParameter<SpendReportingParameter, { year: number }, SpendReportModel>;

export const PopulateApiParameter: HandlerType = props => {
    const year = (props.getState() as CustomState).spendReportingState.yearSelected;
    props.apiParameter = {
        year,
    };
};

export const SendDataToApi: HandlerType = async props => {
    const data = await getSpendReport(props.apiParameter.year);
    if (data.successful) {
        props.apiResult = data.result;
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult) {
        props.dispatch({
            type: "Custom/SpendReportingState/SetSpendReportData",
            key: props.apiParameter.year,
            spendReport: props.apiResult,
        } as any);
        markSkipOnCompleteIfOnSuccessIsSet(props);
        props.parameter.onSuccess?.();
    }
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult) {
        markSkipOnCompleteIfOnErrorIsSet(props);
        props.parameter.onError?.();
    }
};

export const DispatchFinishData: HandlerType = props => {
    props.dispatch({
        type: "Custom/SpendReportingState/SetIsLoading",
        isLoading: false,
    } as any);
};

export const chain = [
    PopulateApiParameter,
    SendDataToApi,
    ExecuteOnSuccessCallback,
    ExecuteOnErrorCallback,
    DispatchFinishData,
];

const loadSpendReport = createHandlerChainRunner(chain, "LoadSpendReport");
export default loadSpendReport;
